import { Link } from "react-router-dom";

interface Crumb {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-600"
    >
      <Link to="/" className="flex items-center gap-1 hover:text-primary-600">
        <i className="ri-home-4-line" />
        首页
      </Link>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-400" />
          {item.path ? (
            <Link to={item.path} className="hover:text-primary-600">
              {item.name}
            </Link>
          ) : (
            <span className="text-foreground-950 font-medium">{item.name}</span>
          )}
        </span>
      ))}
    </nav>
  );
}